import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, Search, ShoppingCart, ArrowUpRight } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useFilter } from '../context/FilterContext';

function NavBar() {
  const { cart } = useCart();
  const { searchQuery, setSearchQuery } = useFilter();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const menuButton = useRef(null);
  const itemCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const close = (event) => {
      if (event.key === 'Escape') { setMenuOpen(false); menuButton.current?.focus(); }
    };
    document.addEventListener('keydown', close);
    return () => document.removeEventListener('keydown', close);
  }, []);

  function search(event) {
    event.preventDefault();
    setMenuOpen(false);
    if (location.pathname !== '/products') navigate('/products');
  }

  return (
    <header className="store-header">
      <div className="store-announcement"><div className="store-shell"><span>Authentic African groceries. A taste of home.</span><a href="https://wa.me/16479912413" target="_blank" rel="noopener noreferrer">Chat on WhatsApp <ArrowUpRight size={14} /></a></div></div>
      <div className="store-nav store-shell">
        <Link to="/" className="store-logo" aria-label="Godson Foods home"><img src="/images/icon.png" alt="" /><span>GODSON FOODS<b>.</b></span></Link>
        <form className="store-search" role="search" onSubmit={search}><Search size={19} /><input type="search" value={searchQuery} onChange={event => { setSearchQuery(event.target.value); if (location.pathname !== '/' && location.pathname !== '/products') navigate('/products'); }} placeholder="Search groceries, spices & more…" aria-label="Search products" /><button type="submit" aria-label="Submit product search"><ArrowUpRight size={20} /></button></form>
        <nav className="store-desktop-links" aria-label="Main navigation"><NavLink to="/products">Shop</NavLink><NavLink to="/onsale">Offers</NavLink><NavLink to="/track">Track order</NavLink><a href="#contact">Contact</a></nav>
        <Link to="/cartpage" className="store-cart" aria-label={`Cart, ${itemCount} items`}><ShoppingCart size={22} /><span>{itemCount}</span></Link>
        <button className="store-menu-button" ref={menuButton} type="button" onClick={() => setMenuOpen(!menuOpen)} aria-label={menuOpen ? 'Close menu' : 'Open menu'} aria-expanded={menuOpen} aria-controls="mobile-navigation">{menuOpen ? <X size={24} /> : <Menu size={24} />}</button>
      </div>
      {menuOpen && <nav id="mobile-navigation" className="store-mobile-links store-shell" aria-label="Mobile navigation"><NavLink to="/products">Shop all groceries</NavLink><NavLink to="/onsale">Special offers</NavLink><NavLink to="/track">Track your order</NavLink><a href="#contact" onClick={() => setMenuOpen(false)}>Contact us</a></nav>}
    </header>
  );
}
export default NavBar;
